import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=4d0aaa7c&scoped=true&"
import script from "./Legal.vue?vue&type=script&lang=js&"
export * from "./Legal.vue?vue&type=script&lang=js&"
import style0 from "./Legal.vue?vue&type=style&index=0&id=4d0aaa7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0aaa7c",
  null
  
)

export default component.exports